import React, { useCallback } from "react";
import CategoryManager from "../Common/CategoryManager";
import {
  deleteGalleryAlbum,
  getGalleryAlbums,
  saveGalleryAlbum,
} from "../../../store/actions/councilActions/galleryAlbumAction";

/* Gallery categories. The screen itself is shared with blog categories. */
const GalleryAlbums = () => {
  const load = useCallback(() => getGalleryAlbums({}), []);

  return (
    <CategoryManager
      title="Gallery Categories"
      countLabel="Items"
      countKey="items_count"
      load={load}
      save={saveGalleryAlbum}
      remove={deleteGalleryAlbum}
    />
  );
};

export default GalleryAlbums;
